import axios from 'axios';

// 使用正確的後端 API URL
const API_BASE_URL = 'https://fund-api.lunataiwan.com';

console.log('🔗 API Base URL:', API_BASE_URL);

// 廹立 axios 實例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// 匯款記錄介面定義
export interface RemittanceRecord {
  id: number;
  agent_name: string;
  payment_date: string;
  customer_name: string;
  amount: number;
  bank_name: string | null;
  note: string | null;
  page: string | null;
}

// 分頁資訊介面
export interface PaginationInfo {
  current_page: number;
  page_size: number;
  total_count: number;
  total_pages: number;
  has_next: boolean;
  has_prev: boolean;
}

// API 回應介面
export interface RemittanceResponse {
  status: string;
  data: RemittanceRecord[];
  pagination: PaginationInfo;
}

// 搜尋參數介面
export interface SearchParams {
  agent_name?: string;
  payment_date?: string;
  start_date?: string;
  end_date?: string;
  customer_name?: string;
  bank_name?: string;
  page?: number;
  page_size?: number;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
}

// API 函數
export const remittanceAPI = {
  // 獲取匯款記錄
  getRemittances: async (params: SearchParams = {}): Promise<RemittanceResponse> => {
    const response = await api.get('/remittances', { params });
    return response.data;
  },

  // 匯出Excel檔案
  exportToExcel: async (params: Omit<SearchParams, 'page' | 'page_size'> = {}) => {
    const response = await api.get('/export', { 
      params,
      responseType: 'blob'
    });
    return response;
  },

  // 健康檢查
  healthCheck: async () => {
    const response = await api.get('/health');
    return response.data;
  },

  // 上傳 Excel 文件
  uploadExcel: async (file: File, sheetName: string) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sheet_name', sheetName);
    
    const response = await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

export default api; 